import styled from 'styled-components';
import { LinkButton } from '../../../../../CommonComponents/Button';

export const ModalContent = styled.div`
  padding: 64px 44px 64px 64px;
  display: flex;
  flex-direction: column;
  width: 460px;
  margin-right: 20px; // Prevents horizontal scrollbar on IE11 and Edge
`;

export const Item = styled(LinkButton)`
  border-bottom: 1px solid #ccc;
  color: #444;
  text-align: left;
  height: 60px;
`;

export const DataItemText = styled.div`
  padding: 2px 40px 2px 2px;
  border: 1px solid #fff;
`;

export const DeleteIcon = styled(LinkButton).attrs(() => ({
  prependIcon: 'far fa-trash-alt',
  size: 'small',
}))`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-44%);
  display: none;
  color: #767676;

  &:hover {
    color: #e75953;

    & ~ ${DataItemText} {
      border: 1px solid #e75953;
      background: #fef7f6;
    }
  }
`;

export const EditIcon = styled(LinkButton).attrs(() => ({
  prependIcon: 'fas fa-edit',
  size: 'small',
}))`
  position: absolute;
  right: 4px;
  top: 4px;
  display: none;
  color: #a5a5a5;

  &:hover {
    color: #0078D4;

    & ~ ${DataItemText} {
      border: 1px solid #0078D4;
      background: #f6f9fe;
    }
  }
`;

export const DataItem = styled.div`
  position: relative;
  margin-left: -3px;

  &:hover {
    ${DeleteIcon} {
      display: block;
    }
  }

  &:hover {
    ${EditIcon} {
      display: block;
    }
  }
`;
